import { render, staticRenderFns } from "./site-status.vue?vue&type=template&id=2bc9acf9&scoped=true"
import script from "./site-status.vue?vue&type=script&lang=js"
export * from "./site-status.vue?vue&type=script&lang=js"
import style0 from "./site-status.vue?vue&type=style&index=0&id=2bc9acf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc9acf9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
